import apiUrl from "./config/config";
import axios from "axios";

class productApi
{

  //Get a product 
  static async getProduct(id)
  {

    try
    {

      const response = await axios(apiUrl + `product/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get all products
  static async getProducts(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "product", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }


  //Update a product
  static async updateProduct(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "product", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete a product
  static async deleteProduct(id)
  {

    try
    {

      const response = await axios.delete(apiUrl + `product/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Get a product by serial number
  static async getProductBySerialNumber(code)
  {

    try
    {

      const response = await axios(apiUrl + `product/serial/${code}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get all products with hierarchy and process
  static async getProductsWithProcessByHierarchy(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "product/processbyheriarchy", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get all products for search
  static async getProductForSearch(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "product/search", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

    //duplicate a product file
  static async duplicateProductFile(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "product/duplicate/file", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }


}

export default productApi;
